var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDoor3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 38,
    viewBox: "0 0 27 38",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4589 0.717773H0.541101C0.243037 0.717773 0 0.96081 0 1.25887V36.8523C0 37.1503 0.243037 37.3934 0.541101 37.3934C0.839164 37.3934 1.0822 37.1503 1.0822 36.8523V1.79997H25.9178V36.8523C25.9178 37.1503 26.1608 37.3934 26.4589 37.3934C26.757 37.3934 27 37.1503 27 36.8523V1.25887C27 0.96081 26.757 0.717773 26.4589 0.717773Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2578 3.64878C24.2303 3.60292 24.1982 3.55707 24.1615 3.52038C24.1569 3.51579 24.1569 3.51121 24.1478 3.50662C24.134 3.49287 24.1111 3.48828 24.0927 3.47911C24.0561 3.4516 24.0148 3.42867 23.9689 3.41491C23.9368 3.40574 23.9047 3.40115 23.8726 3.39657C23.8451 3.39198 23.8222 3.38281 23.7947 3.38281H3.20535C2.90728 3.38281 2.66425 3.62585 2.66425 3.92391V36.8714C2.66425 37.1695 2.90728 37.4125 3.20535 37.4125H23.7947C23.8635 37.4125 23.9277 37.3988 23.9919 37.3713C24.0148 37.3621 24.0331 37.3438 24.0561 37.3346C24.0836 37.3162 24.1157 37.3071 24.1432 37.2841C24.1478 37.2796 24.1524 37.2704 24.1569 37.2658C24.1982 37.2291 24.2257 37.1833 24.2532 37.1374C24.2624 37.1191 24.2762 37.1053 24.2853 37.0915C24.3174 37.0228 24.3358 36.9494 24.3358 36.8714V3.91474C24.3358 3.83679 24.3174 3.76342 24.2853 3.69463C24.2807 3.68088 24.267 3.66712 24.2578 3.64878ZM3.74645 36.3212V4.45584H17.0172L8.45585 5.83152C8.19448 5.87279 8.00188 6.10207 8.00188 6.36804V34.409C8.00188 34.6749 8.19448 34.9042 8.45585 34.9455L17.0126 36.3212H3.74645ZM23.2536 36.2249L9.08408 33.9458V6.83118L23.2536 4.55214V36.2249Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2989 20.7013C12.0647 20.7013 12.6654 19.9813 12.6654 19.0596C12.6654 18.1379 12.0647 17.418 11.2989 17.418C10.5331 17.418 9.93237 18.1379 9.93237 19.0596C9.93237 19.9767 10.5331 20.7013 11.2989 20.7013ZM11.2989 18.5002C11.3998 18.5002 11.5786 18.7111 11.5786 19.0596C11.5786 19.4081 11.3952 19.6191 11.2989 19.6191C11.2026 19.6191 11.0146 19.4081 11.0146 19.0596C11.0146 18.7111 11.198 18.5002 11.2989 18.5002Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0,
    y1: 0.717773,
    x2: 35.0202,
    y2: 26.4991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 2.66425,
    y1: 3.38281,
    x2: 33.501,
    y2: 23.0209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 9.93237,
    y1: 17.418,
    x2: 13.1612,
    y2: 20.1056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoor3);
export default __webpack_public_path__ + "static/media/icon-door3.c141252e2d431dc497f5032b76aead8a.svg";
export { ForwardRef as ReactComponent };